import React, { useState } from 'react';
import {
  Button,
  FormGroup,
} from 'reactstrap';
import {
  Formik, Form, Field, ErrorMessage,
} from 'formik';
import * as Yup from 'yup';

const ContactMessage = Yup.object().shape({
  sender: Yup.string()
    .required('Campo obbligatorio'),
  email: Yup.string()
    .email('Mail non valida')
    .required('Campo obbligatorio'),
  message: Yup.string()
    .required('Campo obbligatorio'),
});

const initialValues = {
  sender: '',
  company: '',
  email: '',
  tel: '',
  message: '',
};

const ContactForm = () => {
  const [submitted, setSubmitted] = useState(false);
  const [submitError, setSubmitError] = useState(false);

  const sendForm = (values, {
    setSubmitting,
    resetForm,
  }) => {
    // eslint-disable-next-line no-undef
    fetch('/.netlify/functions/sendTelegramMessage', {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(values),
    })
      .then((response) => {
        if (response.ok) {
          response.json();
        } else {
          throw new Error('Network response was not ok.');
        }
      })
      .then(() => {
        setSubmitted(true);
        setSubmitting(false);
        setSubmitError(false);
        resetForm(initialValues);
      })
      .catch(() => {
        setSubmitted(false);
        setSubmitError(true);
        setSubmitting(false);
      });
  };

  const inputClass = (field, errors, touched) => `form-control${errors[field] && touched[field] ? ' is-invalid' : ''}`;

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={ContactMessage}
      onSubmit={sendForm}
    >
      {({ isSubmitting, errors, touched }) => (
        <Form className="d-flex flex-column justify-content-between h-100">
          <FormGroup>
            <Field name="sender" placeholder="Nome e Cognome" className={inputClass('sender', errors, touched)} />
            <ErrorMessage name="sender">{msg => <div className="invalid-feedback d-block">{msg}</div>}</ErrorMessage>
          </FormGroup>
          <FormGroup>
            <Field name="company" placeholder="Azienda" className={inputClass('company', errors, touched)} />
            <ErrorMessage name="company">{msg => <div className="invalid-feedback d-block">{msg}</div>}</ErrorMessage>
          </FormGroup>
          <FormGroup>
            <Field name="email" placeholder="E-mail" className={inputClass('email', errors, touched)} />
            <ErrorMessage name="email">{msg => <div className="invalid-feedback d-block">{msg}</div>}</ErrorMessage>
          </FormGroup>
          <FormGroup>
            <Field name="tel" placeholder="Telefono" className={inputClass('tel', errors, touched)} />
            <ErrorMessage name="tel">{msg => <div className="invalid-feedback d-block">{msg}</div>}</ErrorMessage>
          </FormGroup>
          <FormGroup>
            <Field name="message" placeholder="Scrivi qui il tuo messaggio" component="textarea" className={inputClass('message', errors, touched)} />
            <ErrorMessage name="message">{msg => <div className="invalid-feedback d-block">{msg}</div>}</ErrorMessage>
          </FormGroup>

          <div className="text-right">
            {submitted && <p className="alert alert-success d-block text-left">Grazie per aver inviato la richiesta</p>}
            {submitError && <p className="alert alert-danger d-block text-left">Errore nell&apos;invio della richiesta</p>}
            <Button
              type="submit"
              disabled={isSubmitting}
              color="primary"
              className="btn-icon"
            >
        Invia richiesta
              {' '}
              <i className="icon-arrow-right" />
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
};


export default ContactForm;
